import { OneUpdatePostDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useUpdatePostActionResolver: OneCreationActionResolver = () => {
  const { navigation } = useNavigation()

  const [updatePost, { loading }] = useMutation(OneUpdatePostDocument, {
    extractorFn: (data) => data.postsMutations.updatePostsPost,
    errorPolicy: 'all',
  })

  const updatePostHandler = async (args: {
    id: string
    title?: string
    description?: string
    allowCommentsAndReactions?: boolean
    deleteCoverImage?: boolean
    startsAt?: string
    location?: string
    sendNotifications?: boolean
  }) => {
    const result = await updatePost({
      variables: {
        id: args.id,
        title: args.title ?? undefined,
        description: args.description ?? undefined,
        allowCommentsAndReactions: args.allowCommentsAndReactions ?? undefined,
        deleteCoverImage: args.deleteCoverImage ?? undefined,
        startsAt: args.startsAt ?? undefined,
        location: args.location ?? undefined,
        sendNotifications: args.sendNotifications ?? undefined,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success && handled.data.post?.id) {
      return {
        to: navigation.communities.post.id.fullPath({ id: handled.data.post.id }),
        data: args,
      }
    }

    return handled
  }

  return {
    resolver: updatePostHandler,
    loading,
  }
}

export const UpdatePostAction: OneCreateAction = {
  actionResolver: useUpdatePostActionResolver,
  policies: [POSTS_POLICIES.postsManage],
}
